import { useState } from 'react';
import { submitPublicRsvp } from '../lib/api';

/**
 * Shared RSVP submission hook for all templates and form styles.
 * Converts camelCase form data to snake_case backend payload.
 */
export default function useRSVPSubmission(slug) {
  const [isSubmitting, setIsSubmitting] = useState(false);
  const [submitError, setSubmitError] = useState(null);
  const [submittedData, setSubmittedData] = useState(null);
  const [showSuccess, setShowSuccess] = useState(false);

  const handleSubmit = async (formData) => {
    setIsSubmitting(true);
    setSubmitError(null);

    const isAttending = formData.attending === true;

    const payload = {
      guest_name: formData.guestName?.trim(),
      email: formData.email?.trim() || null,
      phone: formData.phone?.trim() || null,
      attending_ceremony: isAttending ? !!formData.attendingCeremony : false,
      attending_reception: isAttending ? !!formData.attendingReception : false,
      number_of_guests: isAttending ? (formData.numberOfGuests || 1) : 1,
      dietary_restrictions: isAttending && formData.hasDietRestriction ? (formData.dietaryRestrictions || '') : '',
      special_requests: formData.specialRequests || '',
      status: isAttending ? 'confirmed' : 'declined',
    };

    try {
      await submitPublicRsvp(slug, payload);
      setSubmittedData(formData);
      setShowSuccess(true);
    } catch (err) {
      setSubmitError(err.message || 'Failed to submit RSVP. Please try again.');
    } finally {
      setIsSubmitting(false);
    }
  };

  return { isSubmitting, submitError, submittedData, showSuccess, handleSubmit };
}
